var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0f4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00baef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "participation",
    transform: "translate(-565 -808)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 60,
    height: 60,
    transform: "translate(565 808)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-party",
    transform: "translate(561 804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M42.065,17.44a5.22,5.22,0,1,1,5.22-5.22,5.226,5.226,0,0,1-5.22,5.22M15.22,18.931A5.22,5.22,0,1,0,10,13.711a5.226,5.226,0,0,0,5.22,5.22",
    transform: "translate(2.948 1.474)",
    fill: "#ffb74d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M54.707,26.5,53.49,38.736l3.885,10.42a2.987,2.987,0,0,1,.283.916l1.491,10.5a2.983,2.983,0,1,1-5.9.85L51.823,51.4,47.25,43l-6.188,8.7-2.875,10.12A2.988,2.988,0,0,1,35.32,64a2.948,2.948,0,0,1-.822-.117,3,3,0,0,1-2.048-3.709l2.983-10.5a3.006,3.006,0,0,1,.31-.718l6-11.575L42.776,28l-6.115,4.831-1.374,8.289a2.237,2.237,0,1,1-4.412-.742l1.491-9a2.253,2.253,0,0,1,.625-1.219l7.457-7.5a2.226,2.226,0,0,1,1.3-.642l9.36-1.363,3.87-6.487,4.435-8.922a2.24,2.24,0,1,1,4,2.013l-4.474,9c-.027.051-.054.1-.084.151ZM31.96,16.5a2.263,2.263,0,0,0,.261-1.96l-2.983-9A2.238,2.238,0,1,0,25,6.961l2.637,7.956-4.8,7.248-8.343,1.2L8.634,17.477l1.3-7.857A2.237,2.237,0,1,0,5.523,8.88l-1.491,9a2.256,2.256,0,0,0,.625,1.962l7.411,9.973c-3.491,7-4.808,7.2-5.041,10.453A4.154,4.154,0,0,0,6.983,41.5a2.527,2.527,0,0,0,.112.741L10,61.423a2.983,2.983,0,1,0,5.9-.85L14.44,43c.565-.2,1.214-.877,1.778-1.1l5.461,7.611L19,60.271a3,3,0,0,0,2.17,3.639A2.954,2.954,0,0,0,21.9,64a2.985,2.985,0,0,0,2.89-2.272l2.983-12a3.017,3.017,0,0,0-.364-2.317L23.388,38.5l1.491-9Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M11.1,29.91l-.1.134.186.934Z",
    transform: "translate(3.44 12.958)",
    fill: "#1976d2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipation);
export default __webpack_public_path__ + "static/media/participation.dae023f0491c9db581cb2b6170aaf203.svg";
export { ForwardRef as ReactComponent };